import React from "react";
import * as styles from "./BackButton.module.scss";
import { Link } from "../../Link";
import { useIntl } from "gatsby-plugin-intl";

interface BackButtonProps {
	label?: string;
	back?: "white" | "dark"; // "white" по умолчанию, "dark" — тёмная версия
}

const BackButton: React.FC<BackButtonProps> = ({
	label = "Back",
	back = "white",
}) => {
	const intl = useIntl();
	const isRTL = intl.locale === "ar";

	const projectsPath = "/projects";

	const ArrowIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			style={{
				transform: isRTL ? "scaleX(-1)" : "none",
			}}
		>
			<path
				fill={back === "dark" ? "#3F3F3F" : "#fff"}
				d="m9.293 3.293 1.414 1.414L4.414 11H22v2H4.414l6.293 6.293-1.414 1.414L2 13.414v-2.828z"
			/>
		</svg>
	);

	return (
		<div className={styles.container}>
			<Link
				to={projectsPath}
				className={`${styles.button} ${back === "dark" ? styles.dark : ""}`}
			>
				{ArrowIcon}
				{label}
			</Link>
		</div>
	);
};

export default BackButton;